import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const FinancesRedux = createActions({
  FinancesExcelRequest: [''],
  FinancesExcelSuccess: [''],
  FinancesExcelError: ['error'],
},
{
  prefix: 'FINANCES_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = FinancesRedux
export const FinancesTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const FinancesExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const FinancesExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const FinancesExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.FinancesExcelRequest]: FinancesExcelRequest,
  [Types.FinancesExcelSuccess]: FinancesExcelSuccess,
  [Types.FinancesExcelError]: FinancesExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/FinancesRedux.js